import { createFileRoute } from "@tanstack/react-router";
import ImagesAudit from "@/pages/admin/ImagesAudit";

export const Route = createFileRoute("/admin/images-audit")({
  component: ImagesAudit,
});
